import React from 'react';

import {
  Horse,
} from '../../redux/types';
import {
  tbodyp, reportSectionTitle, reportSection,
} from './horseReportStyle';


interface Props {
  roughageAmount: number
  horse: Horse
}

const calculateRoughageEvaluation = (roughageAmount: number, horse: Horse) => {
  let roughageValue: number = (roughageAmount / (horse.weight)) * (100 / 1);
  roughageValue = Math.round(roughageValue * 1e2) / 1e2;
  const roughageValueString = `This diet contains ${roughageValue}% roughage per kg BW.`;
  if (roughageValue >= 1.5) {
    return `${roughageValueString} The level of roughage in the diet is acceptable.`;
  } if (roughageValue >= 1) {
    return `${roughageValueString} The level of roughage in the diet is low.`;
  }
  return `${roughageValueString} The level of roughage in the diet is too low.`;
};

const HorseReportFibreInfo : React.FC<Props> = (props: Props) => (
  <div style={reportSection}>
    <div style={reportSectionTitle}>FIBRE</div>
    <p style={tbodyp}>
      Fibre is a structural carbohydrate which is primarily digested by the billions of microbes living in the hindgut. Most of
      your horse’s fibre requirements will by met by forage (grass, hay, haylage, chaff, etc). Connolly’s Red Mills feeds also
      contain ‘super fibres’, highly digestible fibre sources that can be efficiently broken down to provide the horse with
      slow release energy.
    </p>
    <p style={tbodyp}>
      In addition to providing the horse with calories, fibre is required to achieve gut fill which reduces the risk of digestive
      disturbances and to hold water in the gut which serves as a reservoir for the horse.
    </p>
    <p style={tbodyp}>
      Horses are required to eat at least 1% of their bodyweight in roughage  (dry matter) per day to maintain gut function. The
      minimum recommended intake of roughage across all horse class is 1.5% of bodyweight in fibre per day.
    </p>
    <p style={tbodyp}>
      {calculateRoughageEvaluation(props.roughageAmount, props.horse)}
    </p>
  </div>
);

export const HorseReportFibreInfo2 : React.FC<Props> = (props: Props) => (
  <p>
    <b>Fibre:</b> In addition to providing the horse with calories, 
    fibre is required to achieve gut fill which reduces the risk of digestive
    disturbances and to hold water in the gut which serves as a reservoir for the horse. Most of
    your horse’s fibre requirements will by met by forage (grass, hay, haylage, chaff, etc). The
    minimum recommended intake of roughage across all horse class is 
    1.5% of bodyweight in roughage per day.
    {calculateRoughageEvaluation(props.roughageAmount, props.horse)}
  </p>
);

export default HorseReportFibreInfo;
